<template>
  <div id='header'>
    <!-- <div class="logo logos">
        <img src="../assets/img/logo.png" class="imgStyle"/>
    </div>
    <div class="row userPanle">
    <p class="toptits toptit">{{newtit}}</p> -->
    <!-- <div class="logo logos">
        <img src="../assets/img/logo.png" class="imgStyle"/>
    </div> -->
    <div class="row userPanle">
      <div style="display: flex; gap: 12px; align-items: center">
        <img src="../assets/img/logo7.png" class="imgStyle" style="width: 32px;height: 32px;margin-left: 16px"/>
        <!-- <img class="topTxt" src="../assets/img/topTxt.png"/> -->

        <!-- <p class="toptits toptit">{{newtit}}</p> -->
        <p class="toptits toptit">{{ newtit }}</p>
      </div>
      <div class="dropdown" style="gap: 12px">
        <router-link to="/hadoop">
          <el-link :underline="false">
            <i class="el-icon-link" />
            大数据可视化平台
          </el-link>
        </router-link>
        <img src="../assets/img/default-user-avatar.png" alt="" style="width: 32px;height: 32px" v-if="userdata.photo != ''">
        <el-button plain type="primary" style="padding: 8px; margin-right: 8px" v-popover:popover4 class="welcome" @click="personal">
          欢迎您，{{ userdata.nickname }}
          <i class="el-icon-caret-bottom" />
        </el-button>
      </div>
    </div>
    <el-popover
      ref="popover4"
      placement="bottom"
      visible-arrow='false'
      trigger="click">
      <!-- <p class="btn" @click="setup">账号设置</p> -->
      <p class="btn" @click="xgpwd">修改密码</p>
      <p class="btn" @click="signout">退出平台</p>
    </el-popover>
    <el-dialog title="账号信息 / 修改密码" :visible.sync="dialogFormVisible" width="60%">
      <el-form>
        <el-form-item label="* 登录账号" :label-width="formLabelWidth">
          <el-input v-model="userdata.username" :disabled="true" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="passwordo" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" :label-width="formLabelWidth">
          <el-input type="password" v-model="passwordn" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" style="background:#fff;border:1px solid #ccc">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Bus from "../api/Bus";

export default {
  name: 'Header',
  data() {
    return {
      userdata: {},
      dialogFormVisible: false,
      formLabelWidth: '700',
      passwordo: '',
      passwordn: '',
      stat: 1,
      newtit: '',
      newlg: true
    }
  },
  beforeCreate() {
    Bus.$on("unfold", (val) => {    //取  Bus.$on
      this.newlg = val
    });
  },
  created() {
    let userdata = JSON.parse(sessionStorage.getItem('userdata'))
    if (userdata.id == 1) {
      this.$set(this, 'newtit', '乡村群宴智慧管理平台')
    } else if (userdata.level == 0) {
      this.$set(this, 'newtit', '乡村群宴智慧管理平台')
    } else {
      let cityarr = userdata.areasName.split(',')
      this.$set(this, 'newtit', '乡村群宴智慧管理平台')
    }
    this.$set(this, 'userdata', userdata)
  },
  methods: {
    personal() {
      if (this.stat == 1) {
        this.$set(this, 'stat', 2)
      } else {
        this.$set(this, 'stat', 1)
      }
    },
    setup() {
      this.$router.push({
        path: '/rolelist',
        query: {
          id: this.userdata.id
        }
      })
    },
    xgpwd() {
      this.dialogFormVisible = true
      this.passwordo = ''
      this.passwordn = ''
    },
    update() {
      if (this.passwordo === this.passwordn) {
        let data = this.$qs.stringify({
          id: this.userdata.id,
          password: this.passwordo
        })
        this.$axios.post(`/api-r/sys/updateSysPassword`, data, {headers: {accessToken: this.userdata.token}})
          .then(res => {
            if (res.data.success) {
              sessionStorage.removeItem('userdata');
              this.$message({
                message: res.data.msg,
                type: 'success'
              });
              this.$router.push({
                path: '/'
              })
            } else {
              this.$message(res.data.msg)
            }
          })
      } else {
        return this.$message('两次输入不一致，请重新输入');
      }
    },
    signout() {
      this.$confirm('您确定退出当前账号吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.removeItem('userdata');
        localStorage.removeItem('region');
        this.$router.push({
          path: '/'
        })
      }).catch(() => {
      });
    }
  }
}
</script>
<style>
.el-header {
  padding: 0
}


#header .el-popover {
  min-width: 110px
}
</style>
<style scoped lang="scss">
$bba: #11A983;
$fff: #fff;
.userPanle a {
  //font-size: 16px;
  color: #4e40ff !important;
  //letter-spacing: 2px;
}

.logos {
  width: 90px;
  // animation:toplg .5s;
}

@keyframes toplg {
  0% {
    width: 200px;
  }
  100% {
    width: 90px;
  }
}

.newlogo {
  width: 200px;
  animation: toplog .4s;
}

@keyframes toplog {
  0% {
    width: 90px;
  }
  100% {
    width: 200px;
  }
}

.userPanle {
  display: flex;
  align-items: center;
  height: 56px;
  background-color: #ffffff;
  justify-content: space-between;
}

// .userPanle>img{max-height: 65px;margin-left: 180px}
.dropdown {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.dropdown > img {
  max-height: 45px;
}

.logo {
  background-color: $bba;
  position: absolute;

  img {
    width: 100%;
    // height: 94px;
    // object-fit: contain;
  }
}

.welcome {
  border: none;
}

.btn {
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.btn:hover {
  background-color: $bba;
  color: $fff
}

.toptits {
  font-size: 20px;
  //font-family: STZhongsong;
  color: #303133;
  //width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  letter-spacing: 6px;
  font-weight: 600;
}

.toptit {
  // margin-left: -20px;
  // animation:newfont .6s
}

@keyframes newfont {
  0% {
    margin-left: 202px;
  }
  100% {
    margin-left: 92px;
  }
}

.topfont {
  margin-left: 202px;
  animation: tpft .6s;
}

@keyframes tpft {
  0% {
    margin-left: 92px;
  }
  100% {
    margin-left: 202px;
  }
}

.el-icon-caret-bottom, .el-icon-caret-top {
  margin-left: 10px;
}
</style>
